import * as Sentry from "@sentry/browser";
import * as SentryReact from "@sentry/react";
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from "react-router";
import React from "react";

// These variables are injected by webpack.
declare const SENTRY_DSN: string;
declare const SOFTWARE_VERSION: string;

export function initializeSentry(): void {
    const enabled = Boolean(SENTRY_DSN);
    if (!enabled) {
        return;
    }

    Sentry.init({
        dsn: SENTRY_DSN,
        release: SOFTWARE_VERSION,
        integrations: [
            SentryReact.reactRouterV6BrowserTracingIntegration({
                useEffect: React.useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
        ],
        tracesSampleRate: 1.0,
    });
}
